import { render, staticRenderFns } from "./GalleryVideos.vue?vue&type=template&id=31b9ea26"
import script from "./GalleryVideos.vue?vue&type=script&lang=js"
export * from "./GalleryVideos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports